/* eslint-disable react-refresh/only-export-components */
import React, { createContext, useContext, useSyncExternalStore } from 'react';

import { useCartStore } from '@/store/cartStore';

interface CartCountContextValue {
  itemCount: number;
}

const CartCountContext = createContext<CartCountContextValue | undefined>(undefined);

export const CartCountProvider: React.FC<{ children: React.ReactNode }> = ({ children }) => {
  const itemCount = useSyncExternalStore(
    useCartStore.subscribe,
    () => useCartStore.getState().itemCount,
    () => 0
  );

  return <CartCountContext.Provider value={{ itemCount }}>{children}</CartCountContext.Provider>;
};

export const useCartCount = (): CartCountContextValue => {
  const ctx = useContext(CartCountContext);
  if (!ctx) {
    throw new Error('useCartCount must be used within a <CartCountProvider>');
  }
  return ctx;
};
